import { CalendarIcon, FlagIcon, StatusIcon, TicketsIcon, UserIcon } from "app/components/Icons";
import React from "react";


export const getShortIcon = (val: string) => {
  switch (val) {
    case "ticketName":
      return <TicketsIcon />;
    case "status":
      return <StatusIcon color="#79808A" />;
    case "assignee":
      return <UserIcon />;
    case "dueDate":
      return <CalendarIcon />;
    case "priority":
      return <FlagIcon />;
  }
};
